export {default as constDataDialogs} from './dataDialogs';
export {default as constStatus} from './status';



// WEBPACK FOOTER //
// ./src/constants/index.js